import { useSelector } from 'react-redux';

import { ReviewsListContainer } from '../ReviewsList';
import { QuestionsListContainer } from '../QuestionsList';
import { getIsQuestionTab } from '../../selectors/tabs';

export function ItemsListContainer() {
  const isQuestionTab = useSelector(getIsQuestionTab);

  if (isQuestionTab) {
    return <QuestionsListContainer />;
  }

  return <ReviewsListContainer />;
}
